import { render, staticRenderFns } from "./CrudTreeClientMode.vue?vue&type=template&id=27b28310&scoped=true&"
import script from "./CrudTreeClientMode.vue?vue&type=script&lang=js&"
export * from "./CrudTreeClientMode.vue?vue&type=script&lang=js&"
import style0 from "./CrudTreeClientMode.vue?vue&type=style&index=0&id=27b28310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b28310",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCol,VRow,VTreeview})
